// Autor: Leonardo Daniel Oliva - Canal: https://www.youtube.com/@leonardodanieloliva 
// Set the date we're counting down to 
var countDownDate = new Date("Dec 03, 2025 23:59:59").getTime(); 
// Update the count down every 1 second 
var x = setInterval(function() { 
// Get today's date and time 
var now = new Date().getTime(); 
// Find the distance between now and the count down date 
var distance = countDownDate - now; 
// Time calculations for days, hours, minutes and seconds 
var days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, "0"); 
var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, "0"); 
var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, "0"); 
var seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, "0"); 
// Display the result in the element with id="countdown" 
document.getElementById("days").innerHTML = days; 
document.getElementById("hours").innerHTML = hours; 
document.getElementById("minutes").innerHTML = minutes; 
document.getElementById("seconds").innerHTML = seconds; 
// If the count down is finished, write some text 
if (distance < 0) { 
clearInterval(x); 
document.getElementById("countdown").innerHTML = "La oferta ha terminado."; 
} }, 1000);
